// redux-persist migrations table.
// When the reducer's state shape changes in any way that would orphan a
// returning user's persisted state, bump PERSIST_VERSION and add a new
// entry here that transforms the previous shape forward.

export const migrations = {
  1: (state) => ({
    ...state,
    userInfo: {}
  }),
  2: (state) => ({
    ...state,
    csrfToken: ''
  })
};

export const PERSIST_VERSION = 2;
